import {Cureus} from '../Cureus';

Cureus.ImageUploader = {};

//= require_tree ./ImageUploader
